import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { UesFieldDef } from "../../domain/entities/doc-type"
import { makeUpdateDocType } from "../../domain/use-cases/update-doc-type"
import { httpDocTypeRepository } from "../../data/repositories/doc-type-repository"

const updateDocType = makeUpdateDocType(httpDocTypeRepository)

type UpdateDocTypeInput = {
  displayName: string
  description: string
  uesFields: UesFieldDef[]
}

export const useUpdateDocType = (id: string) => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: UpdateDocTypeInput) => updateDocType(id, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["docTypes"] })
      void qc.invalidateQueries({ queryKey: ["docType", id] })
      void qc.invalidateQueries({ queryKey: ["documentUes"] })
    },
  })
}
